import { Route } from "react-router-dom";
import ClientDashboard from "../components/client_panel_dashboard";
import ClientInfo from "../components/client_info";
import ClientDocuments from "../components/client_documents";
import ClientChildIssue from "../components/client_child_issue";
import ClientSelfAssessment from "../components/client_selft_assessment";
import ClientBookAppointment from "../components/client_book_appointment";
import ClientListPayment from "../components/client_list_payment";
import ClientVerify from "../components/client_verify";
import ClientMiddleware from "../../client-middleware/components";
import ClientClaims from "../components/client_claim";

const ClientPanelRoutes = () => (
  <>
    <Route path="panel" element={<ClientMiddleware><ClientDashboard /></ClientMiddleware>}>
      <Route index element={<ClientInfo />} /> 
      <Route path="info" element={<ClientInfo />} />
      <Route path="documents" element={<ClientDocuments />} />
      <Route path="issue" element={<ClientChildIssue />} />
      <Route path="self_assessment" element={<ClientSelfAssessment />} />
      <Route path="book_appointment" element={<ClientBookAppointment />} />
      <Route path="list_payment" element={<ClientListPayment />} />
      <Route path="verify" element={<ClientVerify />} />
      <Route path="claim" element={<ClientClaims />} />
    </Route>
  </>
);


export default ClientPanelRoutes;
